import React from 'react'
import styled from 'styled-components'


const Container = ({ flow = "row", width = "fit-content", padding = "0", justify = "space-between", gap = "20px", bg = "transparent", scroll = "hidden", children }) => {
    return (
        <Wrap $width={width} $flow={flow} $padding={padding} $justify={justify} $bg={bg} $scroll={scroll} $gap={gap}>{children}</Wrap>
    )
}

export default Container


const Wrap = styled.div`
width: ${(props) => (props.$width)};
display: flex;
flex-direction: ${(props) => (props.$flow ? props.$flow : "row")}; 
align-items: center;
column-gap: ${(props) => (props.$gap)};
justify-content: ${(props) => (props.$justify)}; 
background: ${(props) => (props.$bg)};
overflow-x: ${(props) => (props.$scroll)};
padding: ${(props) => (props.$padding)};

`